// src/components/placement/PlacementDiplomaInput.jsx
import React, { useState } from 'react';
import { Download, ArrowLeft, User } from 'lucide-react';
import { generateDiploma } from '../../utils/generateDiploma';

export default function PlacementDiplomaInput({
  finalLevel,
  skillScores,
  onBack,
}) {
  const [userName, setUserName]       = useState('');
  const [generating, setGenerating]   = useState(false);
  const [generated, setGenerated]     = useState(false);
  const [error, setError]             = useState('');

  const handleGenerate = () => {
    if (!userName.trim()) {
      setError('Por favor ingresa tu nombre completo.');
      return;
    }
    if (userName.trim().length < 3) {
      setError('El nombre debe tener al menos 3 caracteres.');
      return;
    }

    setError('');
    setGenerating(true);

    try {
      generateDiploma(userName.trim(), finalLevel, skillScores);
       console.log('userName:', userName);
    console.log('finalLevel:', finalLevel);
    console.log('skillScores:', skillScores);
      setTimeout(() => {
        setGenerating(false);
        setGenerated(true);
      }, 600);
    } catch (e) {
    console.error('Error generando PDF:', e); // ← verás el error real
    setGenerating(false);
    setError(`Error: ${e.message}`); // ← muestra el error real al usuario
  }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleGenerate();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-purple-50 to-white flex flex-col items-center justify-center p-6 gap-6">

      {/* Botón volver */}
      <button
        onClick={onBack}
        className="self-start flex items-center gap-2 text-slate-400 text-sm font-semibold hover:text-indigo-600 transition-colors"
      >
        <ArrowLeft size={16} />
        Volver a resultados
      </button>

      {/* Card principal */}
      <div className="bg-white rounded-3xl shadow-2xl border-2 border-indigo-100 w-full max-w-sm p-8 flex flex-col items-center gap-5">

        {/* Ícono */}
        <div className="w-16 h-16 rounded-3xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shadow-lg shadow-indigo-200">
          <span className="text-3xl">🏆</span>
        </div>

        {/* Título */}
        <div className="text-center">
          <h2 className="text-xl font-black text-slate-800">¡Tu diploma está listo!</h2>
          <p className="text-sm text-slate-500 mt-1">
            Ingresa tu nombre completo tal como aparecerá en el certificado.
          </p>
        </div>

        {/* Preview del nivel */}
        <div className="w-full bg-indigo-50 rounded-2xl px-4 py-3 flex items-center justify-between border border-indigo-100">
          <div>
            <p className="text-[10px] font-black text-indigo-400 uppercase tracking-widest">
              Nivel obtenido
            </p>
            <p className="text-xs text-slate-500 mt-0.5">
              {Object.entries(skillScores || {})
                .map(([k, v]) => `${k === 'grammar' ? 'G' : k === 'vocabulary' ? 'V' : 'R'}: ${v}%`)
                .join(' · ')}
            </p>
          </div>
          <span className="text-3xl font-black text-indigo-600">{finalLevel}</span>
        </div>

        {/* Input nombre */}
        <div className="w-full space-y-2">
          <label className="text-xs font-black text-slate-500 uppercase tracking-widest">
            Nombre completo
          </label>
          <div className="relative">
            <User
              size={16}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-300"
            />
            <input
              type="text"
              value={userName}
              onChange={(e) => {
                setUserName(e.target.value);
                setError('');
                setGenerated(false);
              }}
              onKeyDown={handleKeyDown}
              placeholder="Ej: Carlos Martínez López"
              maxLength={45}
              className={`w-full pl-9 pr-4 py-3 border-2 rounded-2xl text-sm font-semibold text-slate-800 focus:outline-none transition-all
                ${error
                  ? 'border-red-300 focus:border-red-400 ring-2 ring-red-100'
                  : 'border-slate-200 focus:border-indigo-400 focus:ring-2 ring-indigo-100'
                }`}
            />
          </div>

          {/* Contador de caracteres */}
          <p className="text-[10px] text-slate-400 text-right">{userName.length}/45</p>

          {/* Error */}
          {error && (
            <p className="text-xs text-red-500 font-semibold flex items-center gap-1">
              ⚠️ {error}
            </p>
          )}
        </div>

        {/* Botón generar */}
        {!generated ? (
          <button
            onClick={handleGenerate}
            disabled={!userName.trim() || generating}
            className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-4 rounded-2xl font-black text-sm shadow-xl shadow-indigo-200 hover:scale-[1.02] active:scale-[0.98] transition-all flex items-center justify-center gap-2 border-b-4 border-indigo-700 disabled:opacity-40 disabled:scale-100 disabled:border-b-2 disabled:shadow-none"
          >
            {generating ? (
              <>
                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                Generando diploma...
              </>
            ) : (
              <>
                <Download size={18} />
                Descargar Diploma PDF
              </>
            )}
          </button>
        ) : (
          // Estado: ya generado
          <div className="w-full space-y-2">
            <div className="w-full bg-emerald-50 border-2 border-emerald-200 rounded-2xl py-3 px-4 flex items-center justify-center gap-2">
              <span className="text-emerald-600 text-lg">✅</span>
              <p className="text-sm font-black text-emerald-700">¡Diploma descargado!</p>
            </div>

            <button
              onClick={() => {
                setGenerated(false);
                setUserName('');
              }}
              className="w-full bg-slate-100 text-slate-500 py-3 rounded-2xl font-bold text-sm hover:bg-slate-200 transition-colors"
            >
              Generar otro nombre
            </button>
          </div>
        )}

        <p className="text-[10px] text-slate-400 text-center">
          Formato PDF · A4 Portrait · EducaT Mexico
        </p>
      </div>
    </div>
  );
}
